<div class="card bg-{{ backgroundColor }} text-{{ center }} {{ color }}">
  <div class="card-header {{ headerDivider }} {{ headerStyle }}">
    <h5 class="card-title {{ whiteHeader }}">{{ title }}</h5>
    <ng-content select="[headerRight]"></ng-content>
  </div>
  <div class="card-body  {{ styleBody }} ">
    <div class="body">{{ text }}</div>
    <ng-content select="[bodyContent]"></ng-content>
  </div>
  <div class="card-footer {{ footerDivider }}  d-sm-flex justify-content-between align-items-center">
    <p class="card-text d-inline">{{ footer }}</p>
    <ng-content select="[footerContent]"></ng-content>
  </div>
</div>
